export default {"src":"/_next/static/media/Support.ecf7c46a.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};